import React, { useState } from 'react';
import { Modal, Row, Col, Card, Button, Popconfirm, message, notification, Tag, InputNumber } from 'antd';
import moment from 'moment';
import {
  ReloadOutlined,
  RedoOutlined,
  LoadingOutlined,
  FileSyncOutlined,
  CheckCircleTwoTone,
  WarningOutlined,
  PlayCircleOutlined,
  PauseCircleOutlined,
  ClockCircleOutlined,
  CheckCircleOutlined,
  SyncOutlined,
  CloseCircleOutlined,
  InboxOutlined,
  CalendarOutlined,
} from '@ant-design/icons';

const AdminModal = ({
  modalOpen,
  toggleModal,
  campaignOrder,
  reprocessCurrentCampaign,
  reprocessByCadence,
  campaignId,
  onDeleteCampaignOrder,
  scrapeDSPCampaigns,
  reprocessStatus,
  reprocessData,
  pauseCampaign,
  loadingPauseCampaign,
}) => {
  const [processDeleteClick, setProcessDeleteClick] = useState(false);
  const [cadenceValue, setCadenceValue] = useState(7);
  const [cadenceProcessing, setCadenceProcessing] = useState(false);

  const reprocessProps = () => {
    if (reprocessStatus === 'QUEUED') {
      return {
        color: 'warning',
        text: 'Queued',
        icon: <ClockCircleOutlined />,
      };
    } else if (reprocessStatus === 'PROCESSING') {
      return {
        color: 'processing',
        text: 'Processing',
        icon: <SyncOutlined spin />,
      };
    } else if (reprocessStatus === 'FINISHED') {
      return {
        color: 'success',
        text: 'Processed',
        icon: <CheckCircleOutlined />,
      };
    } else if (reprocessStatus === 'FAILED') {
      return {
        color: 'error',
        text: 'Failed',
        icon: <CloseCircleOutlined />,
      };
    }
  };

  const getLastReprocessTimestamp = () => {
    if (!reprocessData) return null;

    // Show the most recent relevant timestamp based on status
    if (reprocessData.dateFinished && reprocessData.status === 'FINISHED') {
      return {
        label: 'Last Completed',
        timestamp: reprocessData.dateFinished,
      };
    } else if (reprocessData.dateProcessed && reprocessData.status === 'PROCESSING') {
      return {
        label: 'Processing Started',
        timestamp: reprocessData.dateProcessed,
      };
    } else if (reprocessData.dateQueued && reprocessData.status === 'QUEUED') {
      return {
        label: 'Last Queued',
        timestamp: reprocessData.dateQueued,
      };
    }
    return null;
  };

  const timestampInfo = getLastReprocessTimestamp();

  // const selectedAdProviderId =
  //   campaignOrder &&
  //   campaignOrder.campaigns &&
  //   campaignOrder.campaigns.map(val => {
  //     let getAdProviderId = [];

  //     if (val.demandSidePlatform === "LIQUIDM") {
  //       getAdProviderId = val.adProviderId;
  //     }

  //     return getAdProviderId;
  //   });

  const confirmDeleteCampaignOrder = async () => {
    try {
      setProcessDeleteClick(true);
      message.success('Successfully Archived the campaign');
      await onDeleteCampaignOrder();
    } catch (err) {
      message.error(err.message || 'Failed to archive campaign');
      setProcessDeleteClick(false);
    }
  };

  const cancelDeleteCampaignOrder = () => {
    setProcessDeleteClick(false);
  };

  return (
    <Modal
      title={'Campaign Admin Tools'}
      visible={modalOpen === 1}
      okText="Export PDF"
      onCancel={() => toggleModal(0)}
      width={'90%'}
      style={{ maxWidth: '1400px' }}
      footer={null}
    >
      <Row gutter={[16, 16]} style={{ margin: 0 }}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Card title="Campaign Reprocessing" style={{ height: '100%' }}>
            <Row type="flex" justify="center" align="middle" style={{ marginBottom: '10px' }}>
              {reprocessStatus && (
                <Tag
                  color={reprocessProps().color}
                  icon={reprocessProps().icon}
                  style={{ marginBottom: '15px' }}
                >
                  {reprocessProps().text}
                </Tag>
              )}
            </Row>

            {timestampInfo && (
              <Row type="flex" justify="center" align="middle">
                <div
                  style={{
                    fontSize: '12px',
                    color: '#666',
                    marginBottom: '20px',
                    textAlign: 'center',
                  }}
                >
                  <div>{timestampInfo.label}:</div>
                  <div style={{ fontWeight: '500' }}>
                    {moment(timestampInfo.timestamp).format('MMM D, YYYY h:mm A')}
                  </div>
                </div>
              </Row>
            )}

            <Row gutter={[24, 16]} style={{ height: '100%' }}>
              <Col xs={24} sm={12}>
                <div style={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  textAlign: 'center'
                }}>
                  <div style={{ flex: 1 }}>
                    <ReloadOutlined
                      style={{
                        fontSize: '48px',
                        marginBottom: '12px',
                        color: '#1890ff',
                      }}
                    />
                    <div
                      style={{
                        marginBottom: '16px',
                        fontSize: '14px',
                        color: '#666',
                        fontWeight: '500',
                      }}
                    >
                      Standard Reprocess
                    </div>
                    <div
                      style={{
                        marginBottom: '16px',
                        fontSize: '12px',
                        color: '#888',
                      }}
                    >
                      This will reprocess the entire campaign
                    </div>
                  </div>
                  <Button
                    type="primary"
                    ghost
                    icon={<RedoOutlined />}
                    style={{ width: '100%' }}
                    onClick={() => {
                      notification.open({
                        message: 'Reprocessing Campaign...',
                        description:
                          'Please wait for a while to Reprocess the Campaign. It may take some time.',
                        icon: <FileSyncOutlined />,
                        duration: 20,
                      });

                      reprocessCurrentCampaign(campaignId);
                    }}
                  >
                    Reprocess Campaign
                  </Button>
                </div>
              </Col>
              <Col xs={24} sm={12}>
                <div style={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  textAlign: 'center'
                }}>
                  <div style={{ flex: 1 }}>
                    <CalendarOutlined
                      style={{
                        fontSize: '48px',
                        marginBottom: '12px',
                        color: '#52c41a',
                      }}
                    />
                    <div
                      style={{
                        marginBottom: '12px',
                        fontSize: '14px',
                        color: '#666',
                        fontWeight: '500',
                      }}
                    >
                      Reprocess by Cadence
                    </div>
                    <div
                      style={{
                        marginBottom: '12px',
                        fontSize: '12px',
                        color: '#888',
                      }}
                    >
                      Process campaign in day batches
                    </div>
                    <div style={{ marginBottom: '12px', fontSize: '12px', color: '#888' }}>
                      Days per batch:
                    </div>
                    <InputNumber
                      min={1}
                      max={30}
                      value={cadenceValue}
                      onChange={setCadenceValue}
                      style={{ width: '80px', marginBottom: '16px' }}
                    />
                  </div>
                  <Button
                    type="primary"
                    ghost
                    icon={<CalendarOutlined />}
                    loading={cadenceProcessing}
                    style={{ width: '100%' }}
                    onClick={async () => {
                      try {
                        setCadenceProcessing(true);
                        notification.open({
                          message: 'Processing Campaign by Cadence...',
                          description: `Processing campaign in ${cadenceValue}-day batches. This may take longer than standard reprocessing.`,
                          icon: <FileSyncOutlined />,
                          duration: 20,
                        });

                        await reprocessByCadence(campaignId, cadenceValue);
                      } catch (error) {
                        notification.error({
                          message: 'Cadence Processing Failed',
                          description: error.message || 'Failed to start cadence processing',
                        });
                      } finally {
                        setCadenceProcessing(false);
                      }
                    }}
                  >
                    Process by Cadence
                  </Button>
                </div>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ margin: 0, marginTop: '16px' }}>
        <Col xs={24} sm={12} md={12} lg={6}>
          <Card title="Campaign Rediscovery" style={{ height: '100%' }}>
            <Row type="flex" justify="center" align="middle">
              <Col span={24} style={{ textAlign: 'center', marginBottom: '20px' }}>
                <ReloadOutlined
                  style={{
                    fontSize: '48px',
                    marginBottom: '12px',
                    color: '#1890ff',
                  }}
                />
                <div
                  style={{
                    marginBottom: '16px',
                    fontSize: '14px',
                    color: '#666',
                  }}
                >
                  This will rediscover campaigns on DSP
                </div>
              </Col>
              <Col span={24} style={{ textAlign: 'center' }}>
                <Button
                  type="primary"
                  ghost
                  icon={<RedoOutlined />}
                  style={{ width: '100%' }}
                  onClick={() => {
                    scrapeDSPCampaigns();
                    notification.open({
                      message: 'Campaign Rediscovery on Progress...',
                      description:
                        'Successfully Rediscover Campaigns in DSP. Please wait for a while for the rediscovery and try to reload the page in a few minutes',
                      icon: <FileSyncOutlined />,
                      duration: 20,
                    });
                  }}
                >
                  Campaign Rediscovery
                </Button>
              </Col>
            </Row>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={12} lg={6}>
          <Card title="Archive Campaign" style={{ height: '100%' }}>
            <Row type="flex" justify="center" align="middle">
              <Col span={24} style={{ textAlign: 'center', marginBottom: '20px' }}>
                <InboxOutlined
                  style={{
                    fontSize: '48px',
                    marginBottom: '16px',
                    color: '#ff7a45',
                  }}
                />
                <div
                  style={{
                    marginBottom: '16px',
                    fontSize: '14px',
                    color: '#666',
                  }}
                >
                  This action cannot be undone.
                </div>
              </Col>
              <Col span={24} style={{ textAlign: 'center' }}>
                <Popconfirm
                  title="Are you sure you want to Archive the campaign?"
                  onConfirm={confirmDeleteCampaignOrder}
                  onCancel={cancelDeleteCampaignOrder}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button
                    type="primary"
                    ghost
                    loading={processDeleteClick}
                    style={{ width: '100%' }}
                    icon={!processDeleteClick ? <InboxOutlined /> : <LoadingOutlined />}
                  >
                    Archive this Campaign
                  </Button>
                </Popconfirm>
              </Col>
            </Row>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={12} lg={6}>
          <Card title="Start Campaign" style={{ height: '100%' }}>
            <Row type="flex" justify="center" align="middle">
              <Col span={24} style={{ textAlign: 'center', marginBottom: '20px' }}>
                <PlayCircleOutlined
                  style={{
                    fontSize: '48px',
                    marginBottom: '16px',
                    color: '#52c41a',
                  }}
                />
                <div
                  style={{
                    marginBottom: '16px',
                    fontSize: '14px',
                    color: '#666',
                  }}
                >
                  Start Campaign
                </div>
              </Col>
              <Col span={24} style={{ textAlign: 'center' }}>
                <Button
                  loading={loadingPauseCampaign && campaignOrder.status === 'PAUSED'}
                  type="primary"
                  style={{ width: '100%' }}
                  disabled={
                    campaignOrder.status === 'LIVE' || campaignOrder.status === 'LIVE_PENDING'
                  }
                  onClick={async () => {
                    try {
                      if (campaignOrder.status === 'PAUSED') {
                        await pauseCampaign({
                          variables: {
                            id: campaignOrder.id,
                          },
                        });

                        notification.open({
                          message: 'Successfully Started Campaign',
                          icon: <CheckCircleTwoTone twoToneColor="#52c41a" />,
                        });
                        setTimeout(() => {
                          window.location.reload();
                        }, 1000);
                      }
                    } catch (err) {
                      console.log(err);
                      notification.open({
                        message: `Failed to Start Campaign: ${err}`,
                        icon: <WarningOutlined style={{ color: 'yellow' }} />,
                      });
                    }
                  }}
                  icon={<PlayCircleOutlined />}
                >
                  Start Campaign Ads
                </Button>
              </Col>
            </Row>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={12} lg={6}>
          <Card title="Pause Campaign" style={{ height: '100%' }}>
            <Row type="flex" justify="center" align="middle">
              <Col span={24} style={{ textAlign: 'center', marginBottom: '20px' }}>
                <PauseCircleOutlined
                  style={{
                    fontSize: '48px',
                    marginBottom: '16px',
                    color: '#faad14',
                  }}
                />
                <div
                  style={{
                    marginBottom: '16px',
                    fontSize: '14px',
                    color: '#666',
                  }}
                >
                  Pause Campaign
                </div>
              </Col>
              <Col span={24} style={{ textAlign: 'center' }}>
                <Button
                  loading={loadingPauseCampaign && campaignOrder.status === 'LIVE'}
                  type="primary"
                  style={{ width: '100%' }}
                  disabled={campaignOrder.status === 'PAUSED'}
                  onClick={async () => {
                    try {
                      if (['LIVE', 'LIVE_PENDING'].includes(campaignOrder.status)) {
                        await pauseCampaign({
                          variables: {
                            id: campaignOrder.id,
                          },
                        });
                        notification.open({
                          message: 'Successfully Paused Campaign',
                          icon: <CheckCircleTwoTone twoToneColor="#52c41a" />,
                        });
                        setTimeout(() => {
                          window.location.reload();
                        }, 1000);
                      }
                    } catch (err) {
                      console.log(err);
                      notification.open({
                        message: `Failed to Pause Campaign: ${err}`,
                        icon: <WarningOutlined style={{ color: 'yellow' }} />,
                      });
                    }
                  }}
                  icon={<PauseCircleOutlined />}
                >
                  Pause Campaign Ads
                </Button>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </Modal>
  );
};

export { AdminModal };
